import {UserLogin} from './user-login.interface';
import {shortHeader} from '../shared/api';
import {APIURL} from 'src/environments/environment';
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, map, retry} from 'rxjs/operators';
import {HandleErrorService} from '../shared/services/handle-error.service';
import {PreParticipanteInterface} from '../participantes/shared/pre-cadastro/participante.interface';
import {ColaboradorConviteInterface} from '../colaboradores/shared/colaborador-convite.interface';
import {ColaboradorConviteCompletoInterface} from '../colaboradores/shared/colaborador-convite-completo.interface';
import {SessionService} from '../shared/services/session.service';
import {NewPassword} from './shared/new-password.interface';
import {NgProgress} from 'ngx-progressbar';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  api = new APIURL();
  private token;
  private sessionToken;

  constructor(
    private http: HttpClient,
    private sessionService: SessionService,
    public ngProgress: NgProgress,
    private handleErrorService: HandleErrorService
  ) {
    this.token = this.sessionService.token;
    this.sessionToken = sessionStorage.getItem('token');
  }

  //
  // ─── Verificadores de Sessao ───────────────────────────────────────────────────────────────────────────
  //
  isLoggedIn(): Observable<any> {
    if (typeof this.token !== 'undefined' && this.token !== null) {
      return of(true);
    }
    return of(false);
  }

  // NOTE Verifica se o usuário está logado usando um sessionStorage
  sessionLoggedIn(): Observable<any> {
    if (
      typeof this.sessionToken !== 'undefined' &&
      this.sessionToken !== null
    ) {
      return of(true);
    }
    return of(false);
  }

  userLogin(request: UserLogin): Observable<any> {
    const headers = shortHeader;
    this.ngProgress.start();
    return this.http.post(this.api.url + '/auth', request, { headers }).pipe(
      map(response => {
        this.ngProgress.done();
        return response;
      }),
      retry(3),
      catchError(error => this.handleErrorService.handleError(error))
    );
  }

  preCadastro(data: PreParticipanteInterface): Observable<any> {
    const headers = this.api.simpleHeaders;
    this.ngProgress.start();
    return this.http
      .post(this.api.url + '/api/participante/preCadastro', data, {
        headers,
        responseType: 'text'
      })
      .pipe(
        map(response => {
          this.ngProgress.done();
          return response;
        }),
        retry(3),
        catchError(error => this.handleErrorService.handleError(error))
      );
  }

  readColaboradorDataToken(
    token: string
  ): Observable<ColaboradorConviteInterface | any> {
    const headers = this.api.simpleHeaders;
    this.ngProgress.start();
    return this.http
      .get(this.api.url + '/api/colaborador/convite/' + token, { headers })
      .pipe(
        map(response => {
          this.ngProgress.done();
          return response;
        }),
        retry(3),
        catchError(response => this.handleErrorService.handleError(response))
      );
  }

  createColaboradorAccount(data: ColaboradorConviteCompletoInterface, token) {
    const headers = this.api.simpleHeaders;
    this.ngProgress.start();
    return this.http
      .put(this.api.url + '/api/colaborador/convite/' + token, data, {
        headers,
        responseType: 'text'
      })
      .pipe(
        map(response => {
          this.ngProgress.done();
          return response;
        }),
        retry(3),
        catchError(response => this.handleErrorService.handleError(response))
      );
  }

  // FIXME Estava tento problemas ao receber o valor do token
  identificaUser(token): Observable<any> {
    this.ngProgress.start();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
      Accept: 'application/json'
    });
    return this.http
      .get(this.api.url + '/api/participante/mySelf/identificadores', {
        headers
      })
      .pipe(
        map(response => {
          this.ngProgress.done();
          return response;
        }),
        retry(3),
        catchError(error => this.handleErrorService.handleError(error))
      );
  }

  resetPassword(login: any): Observable<any> {
    const headers = this.api.simpleHeaders;
    this.ngProgress.start();
    return this.http
      .post(this.api.url + '/api/usuario/resetarSenha', login, { headers, responseType: 'text' })
      .pipe(
        map(response => {
          this.ngProgress.done();
          return response;
        }),
        retry(0),
        catchError(response => this.handleErrorService.handleError(response))
      );
  }

  setPassword(passwordData: NewPassword): Observable<any> {
    this.ngProgress.start();
    const headers = this.api.simpleHeaders;
    return this.http
      .post(this.api.url + '/api/usuario/novaSenha', passwordData, { headers, responseType: 'text'})
      .pipe(
        map(response => {
          this.ngProgress.done();
          return response;
        }),
        retry(0),
        catchError(response => this.handleErrorService.handleError(response))
      );
  }
}
